import React from 'react';
import { Button, Card, CardBody, Spinner, Table } from 'reactstrap';
import TenderNotClosedAlert from '../Components/TenderNotClosedAlert';
import useTenderEvaluationAttendance from '../../../../hooks/useTenderEvaluationAttendance';
import {
  ATTENDANCE_CONFIRMATION_COLUMNS,
  canAccessEvaluationOperationalData,
  displayValue,
  getEvaluationOperationalLockReason,
  getInvitationEvaluationStatusBadgeConfig,
} from '../../../../utils/tenderEvaluationHelpers';

const Attendance = ({ procurement, procId, isActive = true }) => {
  const lockReason = getEvaluationOperationalLockReason(procurement);
  const canAccessData = canAccessEvaluationOperationalData(procurement);
  const procurementId = procurement?.id || procId;
  const { items, isLoading } = useTenderEvaluationAttendance(procurementId, {
    enabled: canAccessData && Boolean(procurementId),
    isActive,
  });

  const renderCellValue = (column, row, index) => {
    if (column.key === 'no') return displayValue(index + 1);
    if (column.key === 'status') {
      const statusConfig = getInvitationEvaluationStatusBadgeConfig(
        row.invitationEvaluationStatus,
        row.status
      );
      return <div className={statusConfig.className}>{statusConfig.label}</div>;
    }
    return displayValue(row[column.key]);
  };

  return (
    <Card className='border shadow-md mb-4'>
      <CardBody>
        <div className='d-flex align-items-start justify-content-between gap-3 mb-3'>
          <div>
            <h5 className='fw-bold text-dark mb-1'>Attendance Confirmation</h5>
            <p className='text-muted small mb-0'>
              Daftar konfirmasi kehadiran peserta tender evaluation.
            </p>
          </div>
          <Button
            color='light'
            className='border text-dark d-flex align-items-center gap-2 flex-shrink-0'
            disabled
          >
            Download to Document
            <i className='ri-download-2-line fs-16'></i>
          </Button>
        </div>

        <hr className='mt-0 mb-3' />

        {!canAccessData ? (
          <TenderNotClosedAlert
            featureLabel='Attendance Confirmation'
            reason={lockReason}
          />
        ) : isLoading ? (
          <div className='text-center py-4'>
            <Spinner size='sm' color='primary' />
            <p className='text-muted mt-2 mb-0 fs-13'>
              Loading attendance confirmation...
            </p>
          </div>
        ) : !items.length ? (
          <div className='text-center text-muted py-4 fs-13'>
            Belum ada data konfirmasi kehadiran.
          </div>
        ) : (
          <div className='table-responsive'>
            <Table className='align-middle table-nowrap mb-0'>
              <thead className='table-light'>
                <tr>
                  {ATTENDANCE_CONFIRMATION_COLUMNS.map(column => (
                    <th key={column.key} className='fs-13'>
                      {column.header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items.map((row, index) => (
                  <tr key={row.id ?? index}>
                    {ATTENDANCE_CONFIRMATION_COLUMNS.map(column => (
                      <td key={column.key} className='text-dark fs-13'>
                        {renderCellValue(column, row, index)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default Attendance;
